<template>
  <div class="undertaking">
    <TableContent />
  </div>
</template>

<script>
import TableContent from './components/TableContent.vue'

export default {
  name: 'Undertaking',
  components: { TableContent },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.undertaking {
  height: 100%;
}
</style>
